(function() {

    angular.module('WebhookProvider', [])
    
    .factory('WebhookModel',
    ['$q', '$http', 'Utils',
    function( $q, $http, Utils) {
        return function(data) {
            var WebhookModel = {
                info: setData(data),
                options: {
                    isSelected: false
                }
            };

            function setData (data) {
                var info = data
                info.id = data._links.self.href.split('/').pop();
                return info;
            }
            
            WebhookModel.rotateSecret = (link) => {
                var deferred = $q.defer();
                var url = WebhookModel.info._links[link].href;
                $http.post(url).then((response) => {
                    WebhookModel.info = setData(response.data);
                    deferred.resolve(WebhookModel);
                }).catch(function(error) {
                    console.log('error', error);
                    deferred.reject(error);
                });
                return deferred.promise
            };

            WebhookModel.update = (webhookOriginal, webhookModified) => {
                var deferred = $q.defer();
                var url = WebhookModel.info._links.self.href;
                var patch = Utils.getObjectsDifferencesForPatching(webhookOriginal.info, webhookModified.info);
                $http.patch(url, patch).then((response) => {
                    WebhookModel.info = setData(response.data);
                    deferred.resolve(response);
                }).catch(function(error) {
                    deferred.reject(error);
                    console.log('error', error);
                });
                return deferred.promise;
            };

            WebhookModel.delete = () => {
                var deferred = $q.defer();
                var url = WebhookModel.info._links.self.href;
                $http.delete(url).then((response) => {
                    deferred.resolve(response);
                }).catch(function(error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            }

    
    
            return WebhookModel;
        }
        }])
    
        .service('WebhookService', [
            '$http', '$q', 'TenantListService', 'WebhookModel',
        function(
            $http, $q, TenantListService, WebhookModel
        ) {
            
            
            this.getPage = () => {
                const deferred = $q.defer();
                const url = TenantListService.currentTenant.info._links["px:webhooks"].href;
                $http.get(url).then((response) => {
                    const listObject = {
                        list: []
                    };
                    
                    if (response.data._embedded){
                        response.data._embedded['px:webhooks'].forEach((webhook) => {
                            listObject.list.push(new WebhookModel(webhook));
                        })
                    }

                    listObject.list.sort((a, b) => {
                        const urlA = a.info.url.replace('https://', '');
                        const urlB = b.info.url.replace('https://', '');
                        return urlA.localeCompare(urlB);
                    });
    
                    deferred.resolve(listObject);
                }).catch(function(error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            }

            this.create = (webhook) => {
                const deferred = $q.defer();
                const url = TenantListService.currentTenant.info._links["px:webhooks"].href;
                $http.post(url, webhook).then((response) => {
                    deferred.resolve(new WebhookModel(response.data));
                }).catch(function(error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            this.delete = (webhooks, callback) => {
                const deferred = $q.defer();
                const deletePromises = webhooks.map(webhooks => {
                    return webhooks.delete();
                });

                $q.all(deletePromises).then((results) => {
                    callback();
                    deferred.resolve(results);
                }).catch((error) => {
                    deferred.reject(error);
                });
                return deferred.promise;
            }
    
        }
    ])

})();